<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="list-btn">
			<RadioGroup v-model="query.type" @on-change="onchange">
				<Radio label="0">
					<span>不限</span>
				</Radio>
				<Radio label="1">
					<span>未分配</span>
				</Radio>
				<Radio label="2">
					<span>已分配</span>
				</Radio>
			</RadioGroup>
			<Button type="primary"  @click="yijianfenpei()">一键分配</Button>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" v-show="row.operator.companyName==null?true:false" @click="fenpei(row.id)">分配</Button>
			    <Button type="error" size="small" disabled="disabled" v-show="row.operator.companyName==null?false:true" >已分配</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading:false,
				total:100,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '货道编号',
						key: 'number'
					},
					{
						title: '运营商',
						key: 'operator',
						render: (h, params) => {
							if (params.row.operator.companyName == null) {
								return h("div",'暂无')
							} else{
								return h("div",params.row.operator.companyName)
							}
						}
					},
					{
						title: '商品',
						key: 'operComm',
						render: (h, params) => {
						   return h("div",params.row.operComm.name)
						}
					},
					{
						title: '最大库存数',
						key: 'maxNumber'
					},
					{
						title: '库存报警数',
						key: 'minNumber'
					},
					{
						title: '可出货数量',
						key: 'currentMayNumber'
					},
					{
						title: '待出货数量',
						key: 'currentNoMayNumber'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				data6: [
					{
						/* id: '1',
						name: '饮料',
						state: '启用',
						createdTime: '2010-10-10',
						cz: '' */
					}
				],
				query:{
					page:0,
					size:10,
					macId:'',
					type:"0"
				},
				fp:{
					aisleId:'',
					operId:'',
					macId:''
				}
			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			yijianfenpei(){
				let _this=this
				
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/mac/leave/factory/aisle/update/oper/yijian',
				    data: {
						macId:_this.fp.macId,
						orderId:_this.fp.orderId
					},
					_this: _this,
					success: function(data) {
						_this.$Message.success('分配成功!');
						_this.ajaxPage()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			fenpei(aiselId) { //修改
			    let _this=this
				_this.fp.aisleId=aiselId
				
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/mac/leave/factory/aisle/update/oper',
				    data: _this.fp,
					_this: _this,
					success: function(data) {
						_this.$Message.success('分配成功!');
						_this.ajaxPage()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			onchange(){
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			ajaxPage() {
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/mac/leave/factory/aisle/page/jm',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.aisles.totalElements
						_this.data6 = data.aisles.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page
	    },
		created(){
			let _this=this
			_this.fp.orderId= this.$route.query.orderId
			_this.query.macId= this.$route.query.macId
			_this.fp.macId= this.$route.query.macId
			this.ajaxPage()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/allotMacAisle/aisleList.vue